import UserTypes from "venuescanner-js/constants/user_type";
const setMethods = (model) => {
  Object.defineProperty(model, "id", {
    get() {
      return model._subjects._value._id;
    },
  });
};
export default setMethods;
